<form *ngIf="vehicleFormGroup" [formGroup]="vehicleFormGroup">
    <p-card class="p-3">
        <ng-template pTemplate="header">
            <div class="flex justify-content-center align-items-center pb-0 gap-2">
                <div class="p-card-title">Datos generales</div>
                <div class="flex-grow-1"></div>
                <div class="flex align-items-center">
                    <label for="active" class="mr-1">Activo</label>
                    <p-inputSwitch formControlName="active" d-form-field-error></p-inputSwitch>
                </div>
            </div>
        </ng-template>
        <div class="grid">
            <div class="col-3">             
                <div class="input-field">
                  <label for="name">Propietario *</label>
                  <p-dropdown [options]="ownerTypes"                    
                            name="OwnerType" optionLabel="name" optionValue="code" [filter]="true"
                            filterBy="name" 
                            placeholder="Seleccione propietario" appendTo="body"
                            formControlName="ownerType" d-form-field-error      
                            (onChange)="onOwnerTypeChange($event)"                     
                            />                            
                </div>              
            </div>
            <div class="col-3">             
                <div class="input-field">
                  <label for="name">Tipo de vehículo *</label>
                  <p-dropdown [options]="vehiclesTypes"                    
                    name="vehicleTypeId" optionLabel="name" optionValue="id" [filter]="true"
                    filterBy="name" 
                    placeholder="Seleccione tipo de vehículo" appendTo="body"
                    formControlName="vehicleTypeId" d-form-field-error/>                            
                </div>              
            </div>
            <div class="col-3">             
                <div class="input-field">
                  <label for="vehicleBrandId">Marca *</label>
                  <p-dropdown [options]="vehiclesBrands"                    
                    name="vehicleBrandId" optionLabel="name" optionValue="id" [filter]="true" [required]="true"
                    filterBy="name" id="vehicleBrandId" (onChange)="loadVehiclesBrandsModel()"
                    placeholder="Seleccione la marca de vehículo" appendTo="body"
                    formControlName="vehicleBrandId" d-form-field-error/>                            
                </div>              
            </div>
            <div class="col-3">             
                <div class="input-field">
                  <label for="vehicleBrandModelId">Modelo *</label>
                  <p-dropdown [options]="vehiclesBrandsModels"                    
                    name="vehicleBrandModelId" optionLabel="name" optionValue="id" [filter]="true"  [required]="true"
                    filterBy="name" id="vehicleBrandModelId"
                    placeholder="Seleccione el modelo del vehículo" appendTo="body"
                    formControlName="vehicleBrandModelId" d-form-field-error/>                            
                </div>              
            </div>
            <div class="col-3">
                <div class="input-field">
                    <label for="name">Nombre *</label>
                    <input pInputText id="name" formControlName="name" d-form-field-error />
                </div>
            </div>
            <div class="col-3">
                <div class="input-field">
                    <label for="plate">Matrícula *</label>
                    <input pInputText id="plate" formControlName="plate" d-form-field-error />
                </div>
            </div>            
            <div class="col-3 input-field">
                <label for="year">Año</label>
                <p-inputNumber name="year" formControlName="year" [min]="1900" id="year"
                d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="yearPurchase">Año de compra</label>
                <p-inputNumber name="yearPurchase" formControlName="yearPurchase" [min]="1900" id="yearPurchase"
                d-form-field-error />
            </div> 
                  
        </div>        
        <div class="grid pt-2">
            <div class="col-3">
                <div class="input-field">
                    <label for="typeOfDriver">Conductor es</label>
                    <p-dropdown [options]="typeOfDrivers"                    
                        name="typeOfDriver" optionLabel="name" optionValue="id" 
                        filterBy="name" id="typeOfDriver" 
                        placeholder="Seleccione el tipo de conductor" appendTo="body"
                        formControlName="typeOfDriver" d-form-field-error/>  
                </div>
            </div>
            <div class="col-3">
                <div class="input-field">
                    <label for="nameOfDriver">Nombre del conductor</label>
                    <input pInputText id="nameOfDriver" formControlName="nameOfDriver" d-form-field-error />
                </div>
            </div>
            <div class="col input-field">
                <label for="notes">Notas</label>
                <textarea pInputTextarea formControlName="notes" style="field-sizing: content;" rows="5" id="notes"
                    d-form-field-error></textarea>
            </div> 
        </div>
        <div class="grid pt-2">
            <div class="col-3">
                <div class="input-field">
                    <label for="policyNumber">Póliza de seguro</label>
                    <input pInputText id="policyNumber" formControlName="policyNumber" d-form-field-error />
                </div>
            </div>
            <div class="col-3">
                <div class="input-field">
                    <label for="policyDateStart">Inicio de póliza</label>
                    <p-calendar [firstDayOfWeek]="1" id="policyDateStart" formControlName="policyDateStart" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                        [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error></p-calendar>
                </div>
            </div>
            <div class="col-3">
                <div class="input-field">
                    <label for="policyDateEnd">Fin de póliza</label>
                    <p-calendar [firstDayOfWeek]="1" id="policyDateEnd" formControlName="policyDateEnd" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                        [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error></p-calendar>
                </div>
            </div>
            <div class="col-3 input-field">
                <label for="policyValue">Importe poliza</label>
                <p-inputNumber name="policyValue" formControlName="policyValue" [min]="0" id="PolicyValue" suffix=" €" d-form-field-error />
            </div>  
        </div>

        <!-- <div class="grid">      
          
            <div class="col-4" *ngIf="vehicle.ownerType == 'WORKER'">             
                <div class="input-field">
                  <label for="name">Operario </label>
                  <p-dropdown [options]="workers"                    
                    name="name" optionLabel="name" optionValue="id" [filter]="true"
                    filterBy="name" 
                    placeholder="Seleccione operario" appendTo="body"
                    formControlName="workerId" d-form-field-error/>                            
                </div>              
            </div>
            <div class="col-4" *ngIf="vehicle.ownerType == 'BUSINESS'">             
                <div class="input-field">
                  <label for="name">Sociedad </label>
                  <p-dropdown [options]="business"                    
                    name="name" optionLabel="name" optionValue="id" [filter]="true"
                    filterBy="name" 
                    placeholder="Seleccione empresa" appendTo="body"
                    formControlName="businessId" d-form-field-error/>                            
                </div>              
            </div>
            <div class="col-2 input-field">
                <label for="active">Activo</label>
                <p-inputSwitch id="active" formControlName="active"></p-inputSwitch>
            </div>           
        </div> -->
        <div class="grid pt-3" *ngIf="vehicle.ownerType == 'BUSINESS'">
            <div class="col-3 input-field">
                <label for="leaseType">Tipo *</label>
                <p-dropdown [options]="leasesType"                    
                          name="leaseType" optionLabel="name" optionValue="id" [filter]="true"
                          filterBy="name"  id="leaseType" [required]="true"
                          placeholder="Seleccione tipo" appendTo="body"
                          formControlName="leaseType" d-form-field-error (onChange)="onLeaseTypeChange()" />
            </div>
        </div>

        <div class="grid pt-2" *ngIf="vehicleFormGroup.get('leaseType')?.value&&vehicle.ownerType == 'BUSINESS'">
            <div class="col-3 input-field">             
                <label for="name">{{vehicleFormGroup.get('leaseType')?.value == 'OnProperty' ? 'Sociedad':'Arrendatario'}} * </label>
                <p-dropdown [options]="business" name="name" optionLabel="name" optionValue="id" [filter]="true"
                filterBy="name" placeholder="Seleccione" appendTo="body" formControlName="businessId" d-form-field-error/>                            
            </div>
            <div class="col-2 input-field" *ngIf="vehicleFormGroup.get('leaseType')?.value == 'OnProperty'">
                <label for="hasFunding">Financiación</label>
                <p-inputSwitch formControlName="hasFunding" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field" *ngIf="vehicleFormGroup.get('leaseType')?.value != 'OnProperty' || (vehicleFormGroup.get('leaseType')?.value == 'OnProperty' && vehicleFormGroup.get('hasFunding')?.value)">
                <label for="vehiclesOwners">{{vehicleFormGroup.get('leaseType')?.value == 'OnProperty' ? 'Financiera':'Arrendador'}} *</label>
                <p-dropdown [options]="vehiclesOwners"                    
                name="vehicleOwnerId" optionLabel="name" optionValue="id" [filter]="true"
                filterBy="name" id="vehicleOwnerId" 
                placeholder="Seleccione" appendTo="body"
                formControlName="vehicleOwnerId" d-form-field-error/>                            
            </div> 
            <div class="col-2 input-field" *ngIf="vehicleFormGroup.get('hasFunding')?.value">
                <label for="dateStart">Fecha inicio</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="dateStart" id="dateStart" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error></p-calendar>
            </div>
            <div class="col-2 input-field" *ngIf="vehicleFormGroup.get('hasFunding')?.value">
                <label for="dateEnd">Fecha fin</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="dateEnd" id="dateEnd" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error></p-calendar>
            </div>     
        </div>
        <div class="grid pt-2" *ngIf="vehicleFormGroup.get('hasFunding')?.value&&vehicleFormGroup.get('leaseType')?.value&&vehicle.ownerType == 'BUSINESS'">            
            <div class="col-4 input-field">
                <label for="quoteNumbers">Nº de cuotas</label>
                <p-inputNumber name="quoteNumbers" formControlName="quoteNumbers" [min]="0" id="quoteNumbers" d-form-field-error />
            </div> 
            <div class="col-4 input-field">
                <label for="quoteValue">Importe de cuotas</label>
                <p-inputNumber name="quoteValue" formControlName="quoteValue" [min]="0" id="quoteValue" suffix=" €" d-form-field-error />
            </div> 
            <div class="col-4 input-field">
                <label for="interestRate">Tipo de interés</label>
                <p-inputNumber name="interestRate" formControlName="interestRate" [min]="0" id="interestRate" suffix=" %" d-form-field-error />
            </div> 
        </div>
        <div class="grid pt-2" *ngIf="vehicleFormGroup.get('leaseType')?.value && vehicleFormGroup.get('leaseType')?.value != 'OnProperty'&&vehicle.ownerType == 'BUSINESS'">            
            <div class="col-4 input-field">
                <label for="kmInit">Km Inicial</label>
                <p-inputNumber name="kmInit" formControlName="kmInit" [min]="0" id="kmInit" d-form-field-error />
            </div> 
            <div class="col-4 input-field">
                <label for="kmEnd">Km actual</label>
                <p-inputNumber name="kmEnd" formControlName="kmEnd" [min]="0" id="kmEnd" suffix=" €" d-form-field-error />
            </div> 
            <div class="col-4 input-field">
                <label for="interestRate">Fecha de lectura</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="interestRate" id="interestRate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error></p-calendar>
            </div> 
        </div>
  
        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>